export default __webpack_public_path__ + "static/media/project8.2d535103.PNG";